var map = {
	"./ecosystem_01_avalanche1.png": "07f0",
	"./ecosystem_01_avalanche2.png": "3ae3",
	"./ecosystem_01_bitcoin.png": "028e",
	"./ecosystem_01_eth.png": "d2b6",
	"./ecosystem_01_fx.png": "80b4",
	"./ecosystem_01_leftball.svg": "4872",
	"./ecosystem_01_outline.svg": "4f62",
	"./ecosystem_01_rightball.svg": "fd1c",
	"./ecosystem_01_solana1.png": "3792",
	"./ecosystem_01_solana2.png": "12e6",
	"./ecosystem_o1_main.png": "8626",
	"./logo_Ultra.png": "302f",
	"./logo_alphaday.png": "75e9",
	"./logo_arbitrum.png": "d906",
	"./logo_asosiasi.png": "e19f",
	"./logo_avalanche.png": "767c",
	"./logo_baklavaspace.png": "e47d",
	"./logo_bccc.png": "82a9",
	"./logo_bitcoin.png": "5544",
	"./logo_bnbchain.png": "ce52",
	"./logo_busd.png": "61c3",
	"./logo_coin98.png": "12aa",
	"./logo_contribution.png": "d45e",
	"./logo_cosmos.png": "5cee",
	"./logo_debank.png": "40b7",
	"./logo_defillama.png": "df60",
	"./logo_ethereum.png": "86e6",
	"./logo_european.png": "5736",
	"./logo_f(x)bridge.png": "a675",
	"./logo_f(x)core.png": "def4",
	"./logo_foxgaming.png": "8d63",
	"./logo_frax.png": "397b",
	"./logo_fxswap.png": "c96b",
	"./logo_fxwallet.png": "62a0",
	"./logo_infineon.png": "8296",
	"./logo_keplr.png": "b7eb",
	"./logo_kronos.png": "72c2",
	"./logo_litecoin.png": "05f1",
	"./logo_maker.png": "dc10",
	"./logo_mapofzones.png": "5409",
	"./logo_marginx.png": "dc07",
	"./logo_metamask.png": "8ff6",
	"./logo_nobi.png": "c8ba4",
	"./logo_optimism.png": "69f6",
	"./logo_osmosis.png": "8e76",
	"./logo_paxos.png": "7160",
	"./logo_pingpub.png": "6ef1",
	"./logo_polygon.png": "14b8",
	"./logo_pudinxchain.png": "34db",
	"./logo_pxcard.png": "a76b",
	"./logo_rabby.png": "e0df",
	"./logo_solana.png": "fa1b",
	"./logo_starscan.png": "30f9",
	"./logo_stasis.png": "53d6",
	"./logo_supra.png": "6849",
	"./logo_teleport.png": "54c2",
	"./logo_tron.png": "1e68",
	"./logo_usdc.png": "8c10",
	"./logo_usdt.png": "1949",
	"./logo_walletconnect.png": "746a",
	"./logo_wanchain.png": "033a",
	"./logo_zealy.png": "8625"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "048c";